/**
 * getHelpUrl - returns the documentation / help site URL for tenants.
 *
 * Centralized here so the help URL lives in one place. Sourced from
 * the build-time env var `VITE_HELP_DOCS_URL`; if missing, falls
 * back to the TNN support docs site.
 */
export function getHelpUrl(): string {
  const fromEnv = import.meta.env.VITE_HELP_DOCS_URL;
  if (typeof fromEnv === "string" && fromEnv.length > 0) {
    return fromEnv;
  }
  return "https://support.tnnops.org";
}

/** Human-readable label for the help documentation link. */
export const HELP_LINK_LABEL = "Help & Docs";

/** Slightly longer copy used in onboarding/dashboard contexts. */
export const HELP_CARD_HEADLINE = "Need a hand?";
/** Copy for the "schedule time with TNN" help card. */
export const HELP_CARD_BODY =
  "Andy from TNN holds open office hours during the pilot rollout. Book a 30-minute slot - virtual or on-site - to get unstuck on anything.";
